module.exports = __webpack_public_path__ + "img/success.fe2918a5.png";